import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Col, Typography } from 'antd';
import { setHeroTitle, setHeroContent, setHeroImage } from '../../redux/hero.slice'
const { Title, Paragraph } = Typography;

import Pricing from '../../shared/Pricing/Pricing'
import FAQSection from '../Home/FAQSection';

const PricingPage = () => { 
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setHeroImage(false));
    dispatch(setHeroTitle(`Simple, transparent pricing`))
    dispatch(setHeroContent(`Whether you're a casual club just getting started or a growing group ready to level up, ShuttleOps gives you the tools you need — without the complexity. Only pay for what you need, and let the app do the heavy lifting so you can focus on playing.`))
  }, [dispatch]);
  return ( 
    <>
      <Pricing/>
      <FAQSection 
        full={true}
        pricing={true}
        hasBackground={false}
        />
    </>
  )
}

export default PricingPage;